import React from 'react';
import { Text, Title } from '@sba/design-system';
import styles from './InfoView.module.css';

type InfoViewProps = { title: string; message: string; image: string };

export default function InfoView({ title, message, image }: InfoViewProps) {
  return (
    <div className={styles.container}>
      <img src={`/assets/${image}`} alt="Error" className={styles.image} />
      <Title level="H1" className={styles.title}>
        {title}
      </Title>
      <Text className={styles.message}>{message}</Text>
    </div>
  );
}
